import { defineMessages } from 'react-intl';

interface TMessages {
    [key: string]: {
        id: string;
        defaultMessage?: string;
        description?: string;
    };
}

export const messages: TMessages = defineMessages({
    moreInformation: {
        id: 'More information',
        defaultMessage: 'More information'
    },
    companySearch: {
        id: 'Company search',
        defaultMessage: 'Company search'
    },
    companyAddress: {
        id: 'Company address',
        defaultMessage: 'Company address'
    },
    other: {
        id: 'Other',
        defaultMessage: 'Other'
    },
    companyType: {
        id: 'Company type',
        defaultMessage: 'Company type'
    },
    companyNumber: {
        id: 'Company number',
        defaultMessage: 'Company number'
    },
    nipNumber: {
        id: 'NIP number',
        defaultMessage: 'NIP number'
    },
    tradingAs: {
        id: 'Trading name',
        defaultMessage: 'Trading name'
    },
    website: {
        id: 'Website',
        defaultMessage: 'Website'
    },
    industry: {
        id: 'What does the business do?',
        defaultMessage: 'What does the business do?'
    },
    chooseIndustryPlaceholder: {
        id: 'Choose an industry',
        defaultMessage: 'Choose an industry'
    },
    chooseCompanyTypePlaceholderDE: {
        id: 'Choose a legal form',
        defaultMessage: 'Choose a legal form'
    },
    turnoverInLast12Months: {
        id: 'Last 12 months turnover',
        defaultMessage: `Last 12 months' turnover`
    },
    turnoverSinceStartedTrading: {
        id: 'Turnover since you started trading',
        defaultMessage: 'Turnover since you started trading'
    },
    turnoverTooltip: {
        id: 'Just an estimate is fine. If you have been trading for less than a year, enter your total turnover to date.',
        defaultMessage:
            'Just an estimate is fine. If you have been trading for less than a year, enter your total turnover to date.'
    },
    monthlyTurnoverTooltip: {
        id: '_.businessIntroduction.monthlyTurnoverTooltip',
        defaultMessage:
            'If your turnover varies, then please provide your average from the last 3 months.'
    },
    startedTradingDate: {
        id: 'When did the business start trading?',
        defaultMessage: 'When did the business start trading?'
    },
    startedTradingDateTooltip: {
        id: 'Enter the date that your business originally started trading, even if you have since changed the name or registration',
        defaultMessage:
            'Enter the date that your business originally started trading, even if you have since changed the name or registration'
    },
    startedTradingDateSubtext: {
        id: 'New business? Enter the expected launch date',
        defaultMessage: 'New business? Enter the expected launch date'
    },
    companyNotFoundErrorTitle: {
        id: "Oops. We couldn't find your company",
        defaultMessage: "Oops. We couldn't find your company"
    },
    companyNotFoundLinkContent: {
        id: 'enter it manually',
        defaultMessage: 'enter it manually'
    },
    pleaseSelectAnAnswer: {
        id: 'pleaseSelectAnAnswer',
        defaultMessage: 'Please select an answer'
    },
    enterProfitError: {
        id: '_.error.enter_profit',
        defaultMessage: 'Please enter your estimated profit'
    },
    enterProfitTooltip: {
        id: '_tooltip.annual_profit',
        defaultMessage:
            'Enter a negative number if your business is loss making. If you have been trading for less than a year then enter your profit to date.'
    },
    selectIndustryError: {
        id: '_.error.select_industry',
        defaultMessage: 'Please select your industry'
    },
    search: {
        id: 'Search',
        defaultMessage: 'Search'
    },
    onlineSalesRevenue: {
        id: 'Does any of your revenue come from online sales?',
        defaultMessage: 'Does any of your revenue come from online sales?'
    },
    annual_turnover_for_2019: {
        id: '_.rls.business_introduction.annual_turnover_for_2019',
        defaultMessage: 'What was your 2019 annual turnover?'
    },
    is_business_adversely_impacted_by_covid: {
        id: '_.rls.business_introduction.is_business_adversely_impacted_by_covid',
        defaultMessage:
            'Has your business been adversely affected as a result of coronavirus (COVID-19)?'
    },
    is_over_50_percent_of_turnover_from_trading: {
        id: '_.rls.business_introduction.is_over_50_percent_of_turnover_from_trading',
        defaultMessage:
            'Does 50% or more of your businesses turnover come from selling goods or providing services in the UK?'
    },
    plans_to_use_loan_to_support_uk_trading: {
        id: '_.rls.business_introduction.plans_to_use_loan_to_support_uk_trading',
        defaultMessage:
            'Will you use the loan to support business activity within the UK?'
    },
    will_use_loan_for_export_activities: {
        id: '_.rls.business_introduction.will_use_loan_for_export_activities',
        defaultMessage: 'Will you use the loan for exporting?'
    },
    continueButton: {
        id: '_.business_introduction.continueButton',
        defaultMessage: 'Submit details'
    },
    wontAffectCreditScore: {
        id: '_.businesses_introduction.applying_wont_affect_credit_score',
        defaultMessage: "Applying won't affect your credit score"
    }
});

export default messages;
